const keyOf = (requestId) => String(requestId);

const register = (listeners, key, apply) => {
    const applies = listeners.get(key) || new Set();
    applies.add(apply);
    listeners.set(key, applies);
    return () => {
        applies.delete(apply);
        if (!applies.size) listeners.delete(key);
    };
};

export const createUploadOutcomeChannel = () => {
    const listeners = new Map();
    const waiting = new Map();

    const takeWaiting = (key) => {
        const outcomes = waiting.get(key) || [];
        waiting.delete(key);
        return outcomes;
    };

    return {
        listen: (requestId, apply) => {
            const key = keyOf(requestId);
            const stop = register(listeners, key, apply);
            takeWaiting(key).forEach(outcome => apply(outcome));
            return stop;
        },
        deliver: (requestId, outcome) => {
            const key = keyOf(requestId);
            const applies = listeners.get(key);
            if (applies) return applies.forEach(apply => apply(outcome));
            waiting.set(key, [...(waiting.get(key) || []), outcome]);
        },
    };
};

export const uploadOutcomeChannel = createUploadOutcomeChannel();
